// Strictly newer than `version`. An equal build, or a user who has never opened the app, is false.
const isMobileVersionAfterUserVersion = (user, version) => {
  if (!user?.currentAppVersion) return false;

  const [major, minor, build] = version.split('.').map(Number);
  const [existingMajor, existingMinor, existingBuild] = user.currentAppVersion.split('.').map(Number);

  if (existingMajor > major) return true;
  if (existingMajor < major) return false;
  if (existingMinor > minor) return true;
  if (existingMinor < minor) return false;
  if (existingBuild > build) return true;
  if (existingBuild < build) return false;
  return false;
};

module.exports = {
  isMobileVersionAfterUserVersion
};
